import axios from "axios";

// Keep track of last search params to preserve pagination/filter after add/edit/delete
let lastUserSearchParams = {
  page: 0,
  size: 20,
  filters: {},
  sortBy: "lastName",
  sortDirection: "ASC",
};

// ===================== Add User =====================
export const AddUserAction = (formDataToSend) => async (dispatch) => {
  dispatch({ type: "Add_USER_REQUEST_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/users`;

    const response = await axios.post(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "Add_USER_REQUEST_SUCCESS", payload: response.data });

      // Refresh user list while preserving last search state
      try {
        await dispatch(ListUserActionFilter(lastUserSearchParams));
      } catch (err) {
        console.error("Failed to refresh user list after add:", err);
      }
    } else {
      dispatch({ type: "Add_USER_REQUEST_ERROR" });
    }
  } catch (error) {
    dispatch({
      type: "Add_USER_REQUEST_ERROR",
      payload: error.response || error.message,
    });
  }
};

// ===================== Edit User =====================
export const EditUserAction = (formDataToSend, id) => async (dispatch) => {
  dispatch({ type: "EDIT_USER_REQUEST_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/user/${id}`;

    const response = await axios.put(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "EDIT_USER_REQUEST_SUCCESS", payload: response.data });

      // Refresh user list while preserving last search state
      try {
        await dispatch(ListUserActionFilter(lastUserSearchParams));
      } catch (err) {
        console.error("Failed to refresh user list after edit:", err);
      }
    } else {
      dispatch({ type: "EDIT_USER_REQUEST_ERROR" });
    }
  } catch (error) {
    dispatch({
      type: "EDIT_USER_REQUEST_ERROR",
      payload: error.response || error.message,
    });
  }
};

// ===================== Delete User =====================
export const DeleteUserAction = (id) => async (dispatch) => {
  dispatch({ type: "DELETE_USER_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/users/${id}`;

    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "DELETE_USER_SUCCESS" });

      // Refresh user list while preserving last search state
      try {
        await dispatch(ListUserActionFilter(lastUserSearchParams));
      } catch (err) {
        console.error("Failed to refresh user list after delete:", err);
      }
    } else {
      dispatch({ type: "DELETE_USER_ERROR" });
    }
  } catch (error) {
    dispatch({
      type: "DELETE_USER_ERROR",
      payload: error.response || error.message,
    });
  }
};

// ===================== List User with Filter / Search =====================
export const ListUserActionFilter =
  ({
    page = 0,
    size = 20,
    filters = {},
    sortBy = "lastName",
    sortDirection = "ASC",
  } = {}) =>
  async (dispatch) => {
    // Save last search params
    lastUserSearchParams = { page, size, filters, sortBy, sortDirection };

    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const payload = {
        userFullNames: filters.searchTerm ? [filters.searchTerm] : [],
        customerNames: [],
        buildingIds: [],
        status: filters.status ? [filters.status] : [],
        page,
        size,
        sortBy,
        sortDirection,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/search`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      dispatch({ type: "LIST_USER_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({
        type: "LIST_USER_ERROR",
        payload: error.response || error.message,
      });
    }
  };

export const ListUserAction = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "LIST_USER_LOADING" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/getUserList`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "LIST_USER_SUCCESS",
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "LIST_USER_ERROR",
      payload: error.response,
    });
  }
};

  export const DeleteReset = ()  => async (dispatch) => dispatch({
    type: "DELETE_USER_RESET",
  });